var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoordinateUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,10.7h-1.3V9.4c0-0.2-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v1.3H9.4c-0.2,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h1.3v1.3 c0,0.2,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1.3h1.3c0.2,0,0.5-0.2,0.5-0.5S13.1,10.7,12.9,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,9.3V3c0-3.4-14-3.4-14,0V12c0,1.7,3.5,2.6,7,2.6c0.6,0,1.1,0,1.7-0.1c0.6,0.3,1.2,0.5,1.9,0.5 c2.1,0,3.9-1.7,3.9-3.9C15,10.5,14.8,9.8,14.5,9.3z M7.5,1.4c3.7,0,6.1,1,6.1,1.7s-2.4,1.7-6.1,1.7S1.4,3.7,1.4,3S3.8,1.4,7.5,1.4 z M1.4,4.4c1.3,0.8,3.7,1.2,6.1,1.2s4.8-0.4,6.1-1.2v0.9v2.3v0.7c-0.1-0.1-0.2-0.2-0.3-0.3c-0.6-0.4-1.4-0.7-2.2-0.7 C9.7,7.3,8.5,8,7.9,9.1c-0.1,0-0.2,0-0.4,0c-3.7,0-6.1-1-6.1-1.7V4.4z M7.5,13.6c-3.7,0-6.1-1-6.1-1.7V8.8 c1.3,0.8,3.7,1.2,6.1,1.2c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.9,0.4,1.8,0.9,2.5C8,13.6,7.7,13.6,7.5,13.6z M11.1,14.1 c-0.6,0-1.2-0.2-1.7-0.6c-0.7-0.5-1.2-1.4-1.2-2.4c0-0.4,0.1-0.7,0.2-1.1C8.5,9.7,8.7,9.4,9,9.1c0.5-0.6,1.3-0.9,2.1-0.9 c0.4,0,0.8,0.1,1.2,0.3C12.7,8.6,13,8.8,13.2,9c0.1,0.1,0.3,0.3,0.4,0.5c0.3,0.5,0.5,1,0.5,1.6C14.1,12.8,12.8,14.1,11.1,14.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinateUpload);
export default __webpack_public_path__ + "static/media/Coordinate_Upload.ba314bd77319d21b0f06db295490ce63.svg";
export { ForwardRef as ReactComponent };